import { z } from 'zod';
import { validateMessageLength } from '../utils/message-utils';

export const contactJournalSchema = z.object({
  subject: z.string().min(1, 'Subject is required'),
  message: z.string().refine(
    value => {
      const validation = validateMessageLength(value);
      return validation.isValid;
    },
    value => {
      const validation = validateMessageLength(value);
      return { message: validation.error || 'Invalid message' };
    }
  ),
  attachments: z.array(
    z.object({
      name: z.string(),
      extension: z.string(),
      url: z.string().optional(),
      fileId: z.string().optional(),
      isUploading: z.boolean(),
      progress: z.number()
    })
  )
});
